import React from "react";
import login_avatar from "assets/img/login-avatar.svg";

function LoginAvatar() {
  return <img className="m-auto" src={login_avatar} alt="brand" />;
}

export default LoginAvatar;
